module.exports = __webpack_public_path__ + "static/media/certificate-image.2cb8637d.png";